<template>

  <div class="dropdown">
    <label class="filter-item-title">{{ label }}</label>
  <!--          <input v-model.trim="CaseSummary"-->
  <!--                 type="text"-->
  <!--                 :class="{'filter-item-input': true, 'filter-item-input-complete': CaseSummary}"-->
  <!--                 :placeholder="$t('toolbox.filtre_case_summary')"-->
  <!--                 style="width: 100%">-->
  <!--          </span>-->
  <!--          <select v-model.trim="CaseSummary" class="filter-item-content w-100" style="padding:0.5rem;">-->
  <!--            <option value="" selected>&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</option>-->
  <!--            <option v-for="rowName in AllRowName" :value="rowName">-->
  <!--              {{ $t(`toolbox.req_summary_case.${rowName}`) }}-->
  <!--            </option>-->
  <!--          </select>-->
    <input
        class="filter-item-content w-100" style="padding:0.5rem;"
        type="text"
        v-model="referenceTestInput"
        :placeholder="label"
        @click="isDropdownOpen = true"
        @focusout="isDropdownOpen = false"
    />
    <ul v-if="isDropdownOpen && filteredOptions.length > 0" style="z-index: 9" class="z-3 position-absolute dropdown-list filter-item-content w-100">
      <li
          v-for="(rowName,index) in filteredOptions"
          :key="index"
          @mousedown.prevent="selectOption(rowName)"
      >
        {{ $t(`${tradPath}.${rowName}`) }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'InputFilterDropDownList',
  props: {
    label: {
      type: String,
      default: ''
    },
    itemList: {
      type: Array
    },
    tradPath: {
      type: String,
      default: ''
    },
    resetTrigger: Number
  },
  data(){
    return {
      isDropdownOpen: false,
      referenceTestInput: ''
    }
  },
  watch: {
    resetTrigger() {
      this.referenceTestInput = ''
    }
  },
  computed: {
    filteredOptions (){
      if(this.referenceTestInput.length === 0)
        return this.itemList
      else {
        return this.itemList.filter(row => {
          let trad = this.$t(this.tradPath + '.' + row)
          return trad.toLowerCase().includes(this.referenceTestInput.toLowerCase())
        });
      }
    }
  },
  methods: {
    selectOption(rowName) {
      this.referenceTestInput =  this.$t(this.tradPath + '.' + rowName)
      this.CaseSummary = rowName
      this.$emit('update-val', rowName)
      this.isDropdownOpen = false
    }
  }
}
</script>

<style scoped>
.dropdown input {
  background: white;
}
.dropdown-list {
  position: absolute;
  width: 100%;
  background: white;
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
  list-style: none;
  padding: 0;
  margin: 0;
}

.dropdown-list li {
  padding: 8px;
  cursor: pointer;
}

.dropdown-list li:hover {
  color : white;
  background: var(--primary)
}

</style>